import { BASE_URL, API_KEY } from "../../configuration/apiconfig";
import UserStore from "../../store/UserStore";
import API from "../../api/api";
import moment from "moment";
export default class PayoutService {
  key = localStorage.getItem("apiKey");
  PayoutTiles = async () => {
    return await API.API.get("payout/payout_tiles")
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  PendingTable = async (start, length, startDate, endDate) => {
    console.log("date in service =====", startDate, endDate);
    return await API.API.get(
      "payout/encashment-history?length=" +
        length +
        "&start=" +
        start +
        "&start_date=" +
        startDate +
        "&end_date=" +
        endDate
    )

      .then((res) => {
        console.log("==== respose======");
        console.log(res.data);
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };

  exportData = async (start, length, startDate, endDate) => {
    let start_date = moment(startDate, "YYYY-MM-DD"); // Parse with format if needed
    let end_date = moment(endDate, "YYYY-MM-DD");
    console.log(
      start_date,
      end_date,
      "START AND END DATE ===== IN EXPORT DATA"
    );
    let newStartDate = start_date.format("Y-MM-DD");
    let newEndDate = end_date.format("Y-MM-DD");
    return await API.API.get(
      "payout/encashment-export-data?length=" +
        length +
        "&start=" +
        start +
        "&start_date=" +
        newStartDate +
        "&end_date=" +
        newEndDate
    )

      .then((res) => {
        console.log("==== respose==== ==");
        console.log(res.data);
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };

  RejectedTable = async (start, length, order = "", dierection = "asc") => {
    return await API.API.get(
      "payout/rejected_list?length=" +
        length +
        "&start=" +
        start +
        "&order=" +
        order +
        "&direction=" +
        dierection
    )
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };
  ApprovedTable = async (start, length, order = "", dierection = "asc") => {
    return await API.API.get(
      "payout/approved_pending_list?length=" +
        length +
        "&start=" +
        start +
        "&order=" +
        order +
        "&direction=" +
        dierection
    )
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };
  PaidTable = async (start, length, order = "", dierection = "asc") => {
    return await API.API.get(
      "payout/approved_paid_list?length=" +
        length +
        "&start=" +
        start +
        "&order=" +
        order +
        "&direction=" +
        dierection
    )
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };
  CancelRequest = async (id) => {
    return await API.API.post("payout/payout_request_cancelation", id)
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  PayoutRequest = async (data = null) => {
    return await API.API.post("payout/payout_request", data)
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        console.log(error.config);
      });
  };
  GetPayoutRequest = async (data = null) => {
    return await API.API.get("payout/payout_request", data)
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        console.log(error.config);
      });
  };

  GetCountryDetails = async () => {
    return await API.API.get("replica_register/availableCountries")
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //encashment transfer to ewallet
  encashmentTransferToWallet = async (data = null) => {
    return await API.API.post("payout/encashment-transfer", data)
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        console.log(error.config);
      });
  };

  encashmentTransfer = async (data = null) => {
    return await API.API.post("payout/encashment-transfer", data)
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        console.log(error.config);
      });
  };

  pickUpAssignedTransfer = async (formData) => {
    return await API.API.post("payout/pickup-assigned", formData)
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        console.log(error.config);
      });
  };

  getDebitMemo = async () => {
    return await API.API.get("payout/get-debit-memo")
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
}
